import styled from "styled-components";
import img from "./img/get-in-touch.jpg";



export const Illustration = styled.section`
position: relative;
background-image: url(${img});
background-size: cover;
background-position: center;
width: 100%;
padding-bottom: 35%;
`
//background-image: url(${require('./img/get-in-touch.jpg')});
//background-image: url(${img});
//background-image: url(${process.env.PUBLIC_URL + 'image/image__Illustration-jpg/get-in-touch.jpg'});

export const IllustrationTextPosition = styled.div`
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
`

export const IllustrationTitle = styled.div`
text-align: center;
font-size: 1.5rem;
font-weight:700;
@media (max-width:25rem) {
   font-size: 1rem;
}
`
export const IllustrationButtonPosition = styled.div`
text-align: center;
margin: 2.2rem 0 1rem;
@media (max-width:30rem) {
 margin-top: 0.5rem;
}
`
